import { createContext, ElementType, useContext } from 'react';
import noop from '../../../lib/doNothing';
import { ICoordinates } from '../../../types/ICoordinates';

export type Callback = (coords: ICoordinates, width: number) => void;

export type DragAndDropContextState = {
  id: string;
  Preview: ElementType<any>;
  props: any;
  previewWidth: number;
};

export type DragAndDropContextType = {
  draggedItem: DragAndDropContextState | null;
  subscribeForNewMousePosition(callback: Callback): () => void;
  newMousePosition: Callback;
  setDraggedItem(item: DragAndDropContextState): void;
  resetDraggedItem(): void;
};
const DragAndDropContext = createContext<DragAndDropContextType>({
  draggedItem: null,
  subscribeForNewMousePosition: () => noop,
  newMousePosition: noop,
  setDraggedItem: noop,
  resetDraggedItem: noop,
});

export const DragAndDropContextProvider = DragAndDropContext.Provider;
export const useDragAndDropContext = () => useContext(DragAndDropContext);
